<template>
  <div style="max-width: 1446px;">
    <SetupWizard v-if="showWizard" class="mb-3"></SetupWizard>
    <v-carousel
      v-else
      width="100%"
      height="240"
      hide-delimiters
      show-arrows-on-hover
      cycle
      dark
      interval="10000"
      class="mb-3"
    >
      <v-carousel-item v-for="(item, i) in announcements" :key="i">
        <v-sheet
          height="100%"
          color="secondary"
          :style="{'background-image': 'url(' + item.backgroundUrl + ')'}"
          style="background-size: cover"
        >
          <v-row class="fill-height pa-8" align="start" justify="center">
            <v-container style="background-color: rgba(0,0,0,0.5)" class="col-6">
              <v-container class="text-h5 white--text ma-0 pa-0 text-center">
                <span>{{ item.title }}</span>
              </v-container>
              <v-container class="text-body-1 white--text text-center">{{ item.content }}
              </v-container>
              <v-container class="text-center">
                <v-btn outlined @click="openLink(item.action.href)">{{ item.action.label }}</v-btn>
              </v-container>
            </v-container>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <div class="cards pa-0 mx-n3">
      <LabCard v-for="(item, i) in labs" :key="i" :info="item"></LabCard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LabCard from '../components/LabCard.vue';
import SetupWizard from '../components/SetupWizard.vue';

export default {
  name: 'Labs',
  components: { LabCard, SetupWizard },
  data: () => ({
    interval: null,
  }),
  computed: {
    ...mapGetters(['announcements', 'showWizard']),
    labs() {
      return this.$store.getters.online ? this.$store.getters.labs : [];
    },
  },
  methods: {
    openLink(url) {
      if (url.startsWith('/')) {
        this.$router.push(url);
      } else {
        window.open(url, '_blank');
      }
    },
    heartBeatRequest() {
      const message = {
        action: 'heartbeat_request',
        payload: {},
      };
      this.$store.dispatch('sendMessage', message);
    },
  },
  mounted() {
    this.heartBeatRequest();
    // this.interval = window.setInterval(this.heartBeatRequest, 10000);
  },
  beforeDestroy() {
    // window.clearInterval(this.interval);
  },
  created() {
    this.$store.dispatch('updateAuthorizations');
  },
};
</script>

<style scoped>
.cards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
